// Pure formatting helpers. No domain coupling, so the design system (ui/) and
// any layer can depend on these.

// The single CLP Intl.NumberFormat instance for the whole app. Currency CLP is
// an integer currency, so no fraction digits. Both the formatCLP string helper
// and parts-based renderers (e.g. MoneyTable's formatToParts) share this so the
// formatting options live in exactly one place.
export const clpFormatter = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP',
  maximumFractionDigits: 0,
});

// Formats a number as Chilean pesos: $1.240.000. Returns null for nullish
// input so callers can render an empty state instead of "$0".
export function formatCLP(n) {
  if (n == null || Number.isNaN(Number(n))) return null;
  return clpFormatter.format(Number(n));
}
